import styled, { css } from 'styled-components'
import { Transition } from 'utils/constants'

export const SwitchCustom = styled.span`
  display: inline-block;
  position: relative;
  width: 32px;
  flex: 0 0 32px;
  height: 16px;
  border: 1px solid var(--t-switch-border);
  border-radius: 8px;
  transition: all ${Transition.ms300};
  background-color: var(--t-switch-bg);

  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 10px;
    height: 10px;
    background-color: var(--t-switch-border);
    border-radius: 50%;
    transition:
      transform ${Transition.ms300},
      background-color ${Transition.ms300};
  }

  ${({ $disabled }) =>
    !$disabled &&
    css`
      &:hover {
        border-color: var(--p-blue-500);
        background-color: var(--t-switch-bg);

        &::before {
          background-color: var(--p-blue-500);
        }
      }
    `}
`

export const SwitchWrap = styled.label`
  display: flex;
  align-content: center;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  margin-bottom: 14px;
`

export const SwitchInput = styled.input.attrs({
  type: 'checkbox',
})`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0 0 0 0);

  &:disabled {
    pointer-events: none;
  }

  &:checked ~ ${SwitchCustom} {
    background-color: var(--p-blue-500);
    border-color: var(--p-blue-500);

    &::before {
      background-color: var(--p-neutral-100);
      transform: translateX(16px);
    }
  }

  &:disabled ~ ${SwitchCustom} {
    background-color: var(--t-switch-input-disabled-bg);
    border-color: var(--t-switch-input-disabled-bg);

    &::before {
      background-color: var(--t-switch-pointer-disabled-bg);
    }
  }

  &:checked:disabled ~ ${SwitchCustom} {
    background-color: var(--t-switch-input-disabled-bg);
    border-color: var(--t-switch-input-disabled-bg);

    &::before {
      background-color: var(--t-switch-pointer-disabled-bg);
      transform: translateX(16px);
    }
  }
`

const SwitchLabelStyled = styled.span`
  display: block;
  margin-left: 8px;
  font-size: 14px;
  line-height: 17px;
  color: ${({ $disabled }) =>
    $disabled
      ? 'var(--t-switch-label-disabled-color)'
      : 'var(--switch-label-color, var(--t-input-text-disabled))'};
`

export const SwitchLabel = ({ children, $disabled }) => {
  return <SwitchLabelStyled $disabled={$disabled}>{children}</SwitchLabelStyled>
}
